import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CHIP_DELETE_ICON_CLASS_NAME = 'ChipDeleteIcon';
export const CHIP_DELETE_ICON_CLASS_SLOTS = ['root'] as const;

export type ChipDeleteIconClassSlot =
	(typeof CHIP_DELETE_ICON_CLASS_SLOTS)[number];

export interface ChipDeleteIconClasses {
	root: string;
}

export type ChipDeleteIconClassKey = keyof ChipDeleteIconClasses;

export const getChipDeleteIconUtilityClass = (slot: string) =>
	generateUtilityClass(CHIP_DELETE_ICON_CLASS_NAME, slot);

export const chipDeleteIconClasses: ChipDeleteIconClasses =
	generateUtilityClasses(CHIP_DELETE_ICON_CLASS_NAME, ['root']);

export default chipDeleteIconClasses;
